import React, {useState} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import {compose} from 'redux';
import RSidebar from "./rsidebar";
import {ThunkCretorGetKeywords} from '../../context/reducers/keywordsReducer';

function RSidebarContainer(props)
{
    if(props.keywords.data==null) props.getKeywords();

    if (props.keywords.data)
    return (
        <RSidebar {...props.keywords}/>
    )
}

let mapStateToProps = (state) => ({
    keywords: state.keywords
});

const mapDispatchToProps = (dispatch)=>({
    getKeywords: () => {
        dispatch(ThunkCretorGetKeywords());
    }
});
export default compose(
connect(mapStateToProps, mapDispatchToProps)
)(RSidebarContainer);